import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Libera as rotas /:tenant/... apenas com sessão do mesmo tenant; senão manda ao login único. */
export const tenantAuthGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const tenant = route.paramMap.get('tenant');
  const session = auth.tenantSession();

  if (session && tenant && session.tenant === tenant) {
    return true;
  }
  // Guarda o endereço pedido: depois de entrar, volta-se para onde se ia (um link de e-mail, um favorito).
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
